import { $, type Properties, resolve } from "signlets";

import { feetPerMeter } from "../constants";
import { NumberInput } from "./NumberInput";

export type AltitudeInputProps = {
  altitude: number;
  onChangeAltitude: (_: number) => void;
};

export const AltitudeInput = ({
  altitude,
  onChangeAltitude,
}: Properties<AltitudeInputProps>) => {
  const number = $(() => Math.round(resolve(altitude) * feetPerMeter));

  const onChangeNumber = (_: number) => onChangeAltitude(_ / feetPerMeter);

  return <NumberInput number={number} onChangeNumber={onChangeNumber} />;
};
